/**
 * Created by Dev0 on 05.08.16.
 */
callpy_global.CApi = function() {
   // var $ = $jcallpy,
        _this = this;

    /* ######## CHAT API ######## */

    var _chat = {
        show: function(callback) {
            if (!_this.chat.visibility) {
                document.querySelector("#callpy_wrapper").style.display = 'block';
                $.callpy_chat('show');
                if (callback && typeof callback === "function") {
                    callback();
                }
            }
        },
        hide: function(callback) {
            if (_this.chat.visibility) {
                $.callpy_chat('hide');
                if (callback && typeof callback === "function") {
                    callback();
                }
            }
        },
        callback: function() {
            $.callpy_chat('_callback');
        },
        call: function(video) {
            if (!_this.chat.offline) {
                $.callpy_chat('_call', video?true:false);
            }
        },
        message: function(text) {
            $.callpy_message('add', {
                text: m_callpy.m_user.replacePatterns(text),
                from: 1,
                time: new Date().getTime(),
                read: 1
            });
        },
        send_message: function(text, woRec){
            var message = $.callpy_message('add', {
                text: m_callpy.urlHighlight(text),
                from: 0,
                time: new Date().getTime(),
                self: true
            });

            clearTimeout(m_callpy.m_control.inputTimer);

            m_callpy.m_chat.send_message_click(text, function (responce) {
                console.log('SEND MESSAGE RESPONCE:', responce);
            });
        },
        showDepartmentsMenu: function() {
            $.callpy_status('set', 'departments_show', true);
        },

        shedule_call: function() {
            window.gui.calendarOrderCall.setOrderCall();
        },

        getGMTHours: function() {
            return new Date(new Date().getTime() + (m_callpy.initialize_data.init_data.timestamp - m_callpy.m_user.last_page_time)).getHours();
        },
        getGMTMinutes: function (){
            return new Date(new Date().getTime() + (m_callpy.initialize_data.init_data.timestamp - m_callpy.m_user.last_page_time)).getMinutes();
        },
        getGMTSeconds: function (){
            return new Date(new Date().getTime() + (m_callpy.initialize_data.init_data.timestamp - m_callpy.m_user.last_page_time)).getSeconds();
        },
        getGMTTime: function (){
            return new Date().getTime() + (m_callpy.initialize_data.init_data.timestamp - m_callpy.m_user.last_page_time);
        }
    };

    this.chat = function(method) {
        if (_chat[method]) {
            return _chat[method].apply(this, Array.prototype.slice.call(arguments, 1));
        } else {
            m_callpy.m_logger.warn('Use only methods:');
            for (var key in _chat) {
                m_callpy.m_logger.log(key);
            }
        }
    };

    Object.defineProperty(this.chat, "visibility", {
        get: function() {
            return $.callpy_status('api').visible ? true : false;
        }
    });

    Object.defineProperty(this.chat, "offline", {
        get: function() {
            return $.callpy_status('api').offline ? true : false;
        }
    });

    Object.defineProperty(this.chat, "lastClose", {
        get: function() {
            return m_callpy.m_chat.last_closed ? m_callpy.m_chat.last_closed : null;
        }
    });

    /* ######## CHAT END ######## */

    /* ######## MANAGER OBJECT ######## */

    var _manager = {

    };

    this.manager = function(method) {
        if (_manager[method]) {
            return _manager[method].apply(this, Array.prototype.slice.call(arguments, 1));
        } else {
            m_callpy.m_logger.warn('Use only methods:');
            for (var key in _manager) {
                m_callpy.m_logger.log(key);
            }
        }
    };

    this.manager.prototype = {};

    Object.defineProperty(this.manager, "isBusyWithCall", {
        get: function (){
            return m_callpy.client_data.peer_key?(m_callpy.managers_list[m_callpy.client_data.peer_key].status && m_callpy.managers_list[m_callpy.client_data.peer_key].status != 1):false;
        }
    });

    Object.defineProperty(this.manager, "isOnline", {
        get: function (){
            return m_callpy.client_data.peer_key!=0;
        }
    });

    /* ######## USER OBJECT ######## */
    var _user_callstack = [];
    var _user = {
        changeDepartment: function(name, id, callback) {
            var departments = m_callpy.client_data.site_info.departments;
            if (!id)
            for (var depId in departments){
                if (departments[depId].name == name){
                    id = departments[depId].id;
                    break;
                }
            }
            if (!id) return false;

            $jcallpy.post(callpy_global.php_server + '/d/', {
                action: "change_department",
                site_url: m_callpy.client_data.site,
                user: m_callpy.client_data.key,
                department_id: id,
                channel: m_callpy.client_data.channel
            }, function(data) {
                if (callback && typeof callback === "function")  {
                    setTimeout(function () {
                        callback();
                    }, 200);
                }
                //$.callpy_message('_addSys', {type: 'change_department', text: _("Изменен отдел")});
            });
        },/*
        typed: function(callback) {
            if (callback && typeof callback == "function") {
                _user_callstack.push(callback);
            }
            else {
                if (_user_callstack.length > 0) {
                    for (var i = 0; i < _user_callstack.length; i++) {
                        _user_callstack[i](callback);
                    }
                }
            }
        },*/
        setCustomData: function(data, encrypted){
            if (!m_callpy || !m_callpy.m_user || !m_callpy.m_user.connected_to_rpx){
                setTimeout(callpy_api.user, 500, "setCustomData", data, encrypted);
            }else{
                m_callpy.m_user.setCustomUserData(data, encrypted);
            }
        },
        setLoginData: function(data){
            if (!m_callpy || !m_callpy.m_user || !m_callpy.m_user.connected_to_rpx){
                setTimeout(callpy_api.user, 500, "setLoginData", data);
            }else{
                m_callpy.m_user.setLoginData(data);
            }
        },
        setDepartmentData: function(data){

        },
        setUserData: function(data){

        },
        getCustomData: function(){
            if (!m_callpy || !m_callpy.m_user || !m_callpy.m_user.connected_to_rpx){
                return null;
            }else{
                return m_callpy.m_user.getCustomUserData();
            }
        },
        managerNotification: function(data){
            if (!m_callpy || !m_callpy.m_user || !m_callpy.m_user.connected_to_rpx){
                setTimeout(callpy_api.user, 500, "managerNotification", data);
            }
            else{
                m_callpy.m_bridge.to_peer({action: "notify", managerName: "", message: data["message"]});
            }
        },
        reachGoal: function(data){
            if (m_callpy.client_data.site_info["goals"] && m_callpy.client_data.site_info["goals"][data["goal_id"]])
            m_callpy.m_bridge.to_fms({action: "reach_goal", goal_id: data["goal_id"], element_id: (data["element_id"]?data["element_id"]:0), peer_key: (m_callpy.client_data.peer_key?m_callpy.client_data.peer_key:0), site: m_callpy.client_data.site, domain: m_callpy.client_data.site, referer: encodeURIComponent(window.location.href)});
        }
    };

    this.user = function(method) {
        if (_user[method]) {
            return _user[method].apply(this, Array.prototype.slice.call(arguments, 1));
        } else {
            m_callpy.m_logger.warn('Use only methods:');
            for (var key in _user) {
                m_callpy.m_logger.log(key);
            }
        }
    };

    this.user.prototype = {};

    /*
    EVENTS OBJECT
     */
    var _registeredEvents = {
        'showChat': [],
        'hideChat': [],
        'contactForm': [],
        'departmentForm': [],
        'call': [],
        'textTyping': [],
        'sendMessage': [],
        'dialupStart': [],
        'callStart': [],
        'callEnd': [],
        'managerOn': [],
        'managerOff': [],
        'managerStatus': []
    };
    var _events = {
        'showChat': function(callback, index){
            if (typeof callback != "function") return;
            _registeredEvents['showChat'].push({"func": callback, "index": index})
        },
        'hideChat': function(callback, index){
            if (typeof callback != "function") return;
            _registeredEvents['hideChat'].push({"func": callback, "index": index})
        },
        'contactForm': function(callback, index){
            if (typeof callback != "function") return;
            _registeredEvents['contactForm'].push({"func": callback, "index": index})
        },
        'departmentForm': function(callback, index){
            if (typeof callback != "function") return;
            _registeredEvents['departmentForm'].push({"func": callback, "index": index})
        },
        'call': function(callback, index){
            if (typeof callback != "function") return;
            _registeredEvents['call'].push({"func": callback, "index": index})
        },
        'textTyping': function(callback, index){
            if (typeof callback != "function") return;
            _registeredEvents['textTyping'].push({"func": callback, "index": index})
        },
        'sendMessage': function(callback, index){
            if (typeof callback != "function") return;
            _registeredEvents['sendMessage'].push({"func": callback, "index": index})
        },
        'dialupStart': function(callback, index){
            if (typeof callback != "function") return;
            _registeredEvents['dialupStart'].push({"func": callback, "index": index})
        },
        'callStart': function(callback, index){
            if (typeof callback != "function") return;
            _registeredEvents['callStart'].push({"func": callback, "index": index})
        },
        'callEnd': function(callback, index){
            if (typeof callback != "function") return;
            _registeredEvents['callEnd'].push({"func": callback, "index": index})
        },
        'managerOn': function(callback, index){
            if (typeof callback != "function") return;
            _registeredEvents['managerOn'].push({"func": callback, "index": index})
        },
        'managerOff': function(callback, index){
            if (typeof callback != "function") return;
            _registeredEvents['managerOff'].push({"func": callback, "index": index})
        },
        'managerStatus': function(callback, index){
            if (typeof callback != "function") return;
            _registeredEvents['managerStatus'].push({"func": callback, "index": index})
        }
    };

    this.events = function(method) {
        if (_events[method]) {
            return _events[method].apply(this, Array.prototype.slice.call(arguments, 1));
        } else {
            m_callpy.m_logger.warn('Use only methods:');
            for (var key in _events) {
                m_callpy.m_logger.log(key);
            }
        }
    };

    this.events._fireCallback = function(type){
        if (!_registeredEvents[type]) return;
        var callbacks = _registeredEvents[type].sort(function(a, b){
            return (b.index - a.index);
        });
        for (var i=0; i<callbacks.length; i++){
            callbacks[i].func.apply(null, Array.prototype.slice.call(arguments, 1));
        }
    };

    /*Object.defineProperty(this.user, "typed", {
        get: function() {
            return _user_callstack.length;
        }
    });*/

    Object.defineProperty(this.user, "clientName", {
        get: function (){
            return (m_callpy.client_data.clientInfo && m_callpy.client_data.clientInfo.userData)?m_callpy.client_data.clientInfo.userData.first_name+" "+m_callpy.client_data.clientInfo.userData.last_name:((m_callpy.client_data.clientInfo && m_callpy.client_data.clientInfo.formData && m_callpy.client_data.clientInfo.formData.contactForm)?m_callpy.client_data.clientInfo.formData.contactForm.name:"#"+m_callpy.client_data.key);
        }
    });

    Object.defineProperty(this.user, "client_city", {
        get: function (){
            return (m_callpy.client_data.clientInfo && m_callpy.client_data.clientInfo.additionalData)?m_callpy.client_data.clientInfo.additionalData["city"]:"";
        }
    });

    Object.defineProperty(this.user, "client_region", {
        get: function (){
            return (m_callpy.client_data.clientInfo && m_callpy.client_data.clientInfo.additionalData)?m_callpy.client_data.clientInfo.additionalData["region"]:"";
        }
    });

    Object.defineProperty(this.user, "client_country", {
        get: function (){
            return (m_callpy.client_data.clientInfo && m_callpy.client_data.clientInfo.additionalData)?m_callpy.client_data.clientInfo.additionalData["country"]:"";
        }
    });

    Object.defineProperty(this.user, "phone", {
        get: function (){
            return (m_callpy.client_data.clientInfo && m_callpy.client_data.clientInfo.userData && m_callpy.client_data.clientInfo.userData.mobile_phone && m_callpy.client_data.clientInfo.userData.mobile_phone.length)?m_callpy.client_data.clientInfo.userData.mobile_phone:((m_callpy.client_data.clientInfo && m_callpy.client_data.clientInfo.formData && m_callpy.client_data.clientInfo.formData.contactForm)?m_callpy.client_data.clientInfo.formData.contactForm.phone:"");
        }
    });

    Object.defineProperty(this.user, "browser", {
        get: function (){
            return m_callpy.client_data.browser[0]+" "+m_callpy.client_data.browser[1];
        }
    });

    Object.defineProperty(this.user, "departmentName", {
        get: function (){
            return m_callpy.client_data.site_info.departments[m_callpy.client_data.department_id].name;
        }
    });

    Object.defineProperty(this.user, "activeChat", {
        get: function (){
            if (m_callpy.m_chat && m_callpy.m_chat.history && m_callpy.m_chat.history.length){
                var last = m_callpy.m_chat.history[m_callpy.m_chat.history.length - 1];
                if (last["_id"] && last["_id"]["$id"] && new Date().getTime() - last["timestamp"]*1000 < 15*60*1000) return true;
                else return false;
            }else return false;
        }
    });

};